import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent, createRef } from 'react';
import PT from 'prop-types';
import { S as SplitButtonWrapper, B as ButtonGroupFrame, a as StyledMainButton, b as StyledDropdownButton, H as HiddenLabelText } from './SplitButton.styles-D4vGqYmh.js';
import { L as LoadingIcon } from '../Button-BC9x0UVX.js';
import { S as SplitButtonPopper } from './SplitButtonPopper-CFZ5BUK-.js';
import { T as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { c as composeRefs } from '../../LocalModules/storm-ui-utils/dist/esm/composeRefs-CHPW6wJ8-CHPW6wJ8.js';
import { I as Icon } from '../../Icon/Icon-BAb4rBP0.js';
import { d as ellipsisH } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';

class SplitButton extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "splitDropdownButtonRef", /*#__PURE__*/createRef());
    _defineProperty(this, "anchorRef", /*#__PURE__*/createRef());
    _defineProperty(this, "onCloseHandler", event => {
      var _this$splitDropdownBu;
      if (event && event.target instanceof Node && this.splitDropdownButtonRef && !((_this$splitDropdownBu = this.splitDropdownButtonRef.current) !== null && _this$splitDropdownBu !== void 0 && _this$splitDropdownBu.contains(event.target))) {
        this.togglePopoverView();
      }
    });
    _defineProperty(this, "togglePopoverView", () => {
      this.setState(({
        isPopoverVisible: prevIsPopoverVisible
      }) => ({
        isPopoverVisible: !prevIsPopoverVisible
      }));
    });
    this.state = {
      isPopoverVisible: false
    };
  }
  render() {
    const {
      mainButtonLabel,
      disabled,
      small,
      offset,
      children,
      mainButtonOnClick,
      dropdownLabel,
      fullWidth,
      primary,
      id,
      taktId,
      taktValue,
      loading,
      loadingLabel,
      ...rest
    } = this.props;
    const {
      isPopoverVisible
    } = this.state;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('split-button')
    }, ({
      getDataTaktAttributes
    }) => {
      var _this$anchorRef$curre, _offset$y, _offset$x;
      return /*#__PURE__*/React__default.createElement(SplitButtonWrapper, null, /*#__PURE__*/React__default.createElement(SplitButtonPopper, {
        isOpen: isPopoverVisible,
        onClose: this.togglePopoverView,
        onPopoverClose: this.onCloseHandler,
        $minWidth: this.anchorRef && ((_this$anchorRef$curre = this.anchorRef.current) === null || _this$anchorRef$curre === void 0 ? void 0 : _this$anchorRef$curre.getBoundingClientRect().width),
        focusedAnchorEl: this.splitDropdownButtonRef,
        offsetDistance: Number((_offset$y = offset === null || offset === void 0 ? void 0 : offset.y) !== null && _offset$y !== void 0 ? _offset$y : 0) - 2,
        offsetSkidding: Number((_offset$x = offset === null || offset === void 0 ? void 0 : offset.x) !== null && _offset$x !== void 0 ? _offset$x : 0),
        trigger: triggerProps => /*#__PURE__*/React__default.createElement(ButtonGroupFrame, {
          ref: composeRefs(this.anchorRef, triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.setTriggerElement)
        }, /*#__PURE__*/React__default.createElement(StyledMainButton, _extends({}, getDataTaktAttributes(), rest, {
          id: id,
          type: "button",
          disabled: disabled,
          $small: small,
          $primary: primary,
          $fullWidth: fullWidth,
          onClick: loading ? undefined : mainButtonOnClick,
          $loading: loading
        }, loading && {
          'aria-live': 'assertive'
        }, loading && {
          'aria-disabled': true
        }), loading && /*#__PURE__*/React__default.createElement(LoadingIcon, null), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loading && loadingLabel ? loadingLabel : mainButtonLabel)), /*#__PURE__*/React__default.createElement(StyledDropdownButton, _extends({}, getDataTaktAttributes({
          taktIdSuffix: 'dropdown'
        }), rest, {
          id: typeof id === 'string' ? `${id}-dropdown` : undefined,
          disabled: disabled || loading,
          $small: small,
          $fullWidth: fullWidth,
          $primary: primary,
          onClick: this.togglePopoverView,
          "aria-haspopup": "true",
          "aria-expanded": isPopoverVisible,
          ref: this.splitDropdownButtonRef
        }), /*#__PURE__*/React__default.createElement(HiddenLabelText, null, dropdownLabel), /*#__PURE__*/React__default.createElement(Icon, {
          type: ellipsisH
        })))
      }, children));
    });
  }
}
_defineProperty(SplitButton, "propTypes", {
  small: PT.bool,
  fullWidth: PT.bool,
  primary: PT.bool,
  disabled: PT.bool,
  mainButtonLabel: PT.node.isRequired,
  mainButtonOnClick: PT.func.isRequired,
  /**
   * Use to offset the overlay from the calculated position.
   */
  offset: PT.shape({
    x: PT.number,
    y: PT.number
  }),
  children: PT.node.isRequired,
  /**
   * Hidden label for dropdown. Can be used to pass in localized string.
   */
  dropdownLabel: PT.string,
  /**
   * Main button and dropdown button will have an id based off of this.
   */
  id: PT.string,
  loading: PT.bool,
  loadingLabel: PT.string
});
_defineProperty(SplitButton, "defaultProps", {
  small: false,
  fullWidth: false,
  primary: false,
  disabled: false,
  offset: {
    y: 2,
    x: 1
  },
  dropdownLabel: 'Toggle Dropdown',
  id: undefined,
  loading: false,
  loadingLabel: undefined
});

export { SplitButton as S };
//# sourceMappingURL=SplitButton-TyfhgCxO.js.map
